<template>
  <div>
    <common-form :dataID="dataID"></common-form>
  </div>  
</template>
<script>
import commonForm from './paramForm.vue'
export default {
  data () {
    return {
      dataID: -1 // 参数选项ID
    }
  },
  components: {
    commonForm
  },
  created() {
    if (this.$route.params.id) {
      this.dataID = Number(this.$route.params.id)
    }
  }
}
</script>




// WEBPACK FOOTER //
// edit.vue?39f7a80d